const DEFAULT_FEATURED_IMG_URL = 'https://res.cloudinary.com/producer-news-portal/image/upload/v1650911454/foremost-banner-placeholder.jpg';
const DEFAULT_FEATURED_IMG_ALT = 'Default Featured Image';

const DefaultFeaturedImg = {
    alt: DEFAULT_FEATURED_IMG_ALT,
    source: DEFAULT_FEATURED_IMG_URL,
};

export {
    DEFAULT_FEATURED_IMG_URL,
    DEFAULT_FEATURED_IMG_ALT,
    DefaultFeaturedImg,
};
